import React from 'react';
import { NavLink } from 'react-router-dom';

import styles from './MenuLink.module.scss';

interface MenuLinkProps {
  icon?: React.ReactElement;
  label?: string;
  to: string;
  count?: number;
  title?: string;
}

function getCountDisplayed(count: number | undefined) {
  if (!count || count <= 0) return null;

  return count > 99 ? '99+' : `${count}`;
}

const MenuLink: React.FunctionComponent<MenuLinkProps> = ({ icon, label, to, count, title }) => {
  const countDisplayed = getCountDisplayed(count);

  return (
    <NavLink
      key={to}
      to={to}
      className={({ isActive }) => (isActive ? `${styles.link} ${styles.activeMenu}` : styles.link)}
    >
      <div className={styles.linkContainer} title={title ? title : ''}>
        {icon && <div className={styles.linkIcon}>{icon}</div>}
        {label && <div className={styles.label}>{label}</div>}
        {countDisplayed && <div className={styles.linkCount}>{getCountDisplayed(count)}</div>}
      </div>
    </NavLink>
  );
};

export default MenuLink;
